import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

function ProductOneSchool() {
  usePageMeta(
    'OneSchool Companion',
    'OneSchool Companion is a desktop productivity app that helps teachers cut down on daily admin — install it on your work or home computer.'
  );

  return (
    <>
      <section className="product-hero">
        <div className="container">
          <div className="product-hero-top">
            <span className="badge badge--live">Available</span>
            <span style={{ color: 'var(--text-muted)', fontWeight: 600, fontSize: '0.9rem' }}>
              For teachers · Desktop app
            </span>
          </div>
          <h1>OneSchool Companion</h1>
          <p className="product-hero-lead">
            A productivity companion that lives on your computer — built to
            help teachers keep on top of the daily admin that eats into
            planning and teaching time.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn btn-primary">
              Get in touch to get started
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: 'start' }}>
            <div>
              <h2>What it does</h2>
              <p>
                OneSchool Companion installs directly on your work or home
                computer, so it's there whenever you sit down to plan,
                prepare or catch up on admin — no browser tabs required.
              </p>
              <p>
                It's designed around the day-to-day rhythm of a teacher's
                workload: the small, recurring tasks that add up over a
                week, a term, a year.
              </p>
            </div>
            <div>
              <h2>Built for</h2>
              <ul className="feature-list">
                <li>
                  <span className="feature-tick">✓</span>
                  <span>Classroom teachers looking to reduce time spent on admin</span>
                </li>
                <li>
                  <span className="feature-tick">✓</span>
                  <span>Staying organised across daily and weekly teaching tasks</span>
                </li>
                <li>
                  <span className="feature-tick">✓</span>
                  <span>Keeping your workflow on your own device, not scattered across tools</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="callout">
            <h3 style={{ marginBottom: 8 }}>Want to try OneSchool Companion?</h3>
            <p style={{ marginBottom: 16 }}>
              We're onboarding teachers directly at the moment. Get in touch
              and we'll help you get set up.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Contact us about OneSchool Companion
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductOneSchool;
